module.exports = __webpack_public_path__ + "static/media/tasting.b6f0913a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/tasting.jpg
// module id = 583
// module chunks = 0